// extracted by mini-css-extract-plugin
module.exports = {"answers":"style_answers__1dqWn","answer":"style_answer__3N_P_","result":"style_result__2eZYt","max_correct_answer":"style_max_correct_answer__3m3wa"};